import { createContext } from "react";
import type { IExtractionState } from "@hooks/extraction/useExtraction";
import type { HttpClient } from "@utils/index";
import type { IDoctypeState } from "@src/hooks/flow/useDoctype";

export interface IApplicationContextType {
  extraction: IExtractionState;
  doctype: IDoctypeState;
  httpClient: HttpClient;
}

export const ApplicationContext = createContext<
  IApplicationContextType | undefined
>(undefined);
